/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';

/**
 * 
 * @export
 * @interface MedicalSystemCatalogDto
 */
export interface MedicalSystemCatalogDto {
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemCatalogDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemCatalogDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemCatalogDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof MedicalSystemCatalogDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof MedicalSystemCatalogDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof MedicalSystemCatalogDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemCatalogDto
     */
    model: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MedicalSystemCatalogDto
     */
    locations?: Array<string> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof MedicalSystemCatalogDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemCatalogDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemCatalogDto
     */
    $type?: MedicalSystemCatalogDtoTypeEnum;
}


/**
 * @export
 */
export const MedicalSystemCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoMedicalSystemCatalogDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.MedicalSystemCatalogDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type MedicalSystemCatalogDtoTypeEnum = typeof MedicalSystemCatalogDtoTypeEnum[keyof typeof MedicalSystemCatalogDtoTypeEnum];


/**
 * Check if a given object implements the MedicalSystemCatalogDto interface.
 */
export function instanceOfMedicalSystemCatalogDto(value?: unknown): value is MedicalSystemCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(MedicalSystemCatalogDtoTypeEnum)[0];
}

export function MedicalSystemCatalogDtoFromJSON(json: any): MedicalSystemCatalogDto {
    return MedicalSystemCatalogDtoFromJSONTyped(json, false);
}

export function MedicalSystemCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSystemCatalogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'locations': !exists(json, 'locations') ? undefined : json['locations'],
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function MedicalSystemCatalogDtoToJSON(value?: MedicalSystemCatalogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'iuid': value.iuid,
        'category': RtSystemCategoryToJSON(value.category),
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'locations': value.locations,
        'state': StateOfUseToJSON(value.state),
        'imageId': value.imageId,
        '$type': value.$type,
    });
}

